<template>
  <v-container>
    <div v-if="(questions.length > 0 && currentQuestion >= 0)">
    <v-card class="ma-1 pb-3">
      <v-card-title style="word-break: break-word;">
        <div v-html="question"></div>
        <v-btn icon @click="searchQuestion">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-checkbox
          v-for="option in options"
          class="mt-0"
          :key="option.id"
          :label="option.text"
          :value="option.id"
          v-model="selected"
          :disabled="revealAnswer"
        >
          <template v-slot:label>
            <span
              :class="
                revealAnswer
                  ? option.correct
                    ? 'green--text'
                    : 'red--text'
                  : ''
              "
              v-html="option.text"
            ></span>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters justify="center">
        <v-btn
          color="primary"
          class="mx-2"
          small
          @click="checkAnswer"
          :disabled="selected.length === 0 || revealAnswer"
        >
          Check Answer
        </v-btn>
        <v-btn
          color="primary"
          small
          class="mx-2"
          @click="nextQuestion"
          :disabled="!revealAnswer || currentQuestion === questions.length - 1"
        >
          Next Question
        </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-card class="ma-1 mt-3 text-center">
      <v-card-text class="text-body-1" >
        <Countdown v-if="endDate" :endDate="endDate" negative :stopTimer="correctAnswers + incorrectAnswers === questions.length" >
          <template v-slot="{ hour, min, sec }">
            <span :class="hour < 0 || min < 0 || sec < 0 ? 'red--text' : '' ">Time left: {{ hour }}:{{ min }}:{{ sec }}</span>
          </template>
        </Countdown>

        Question: {{ currentQuestion + 1 }}/{{ questions.length }} <br />
        Correct Answers: {{ correctAnswers }} <br />
        Incorrect answers: {{ incorrectAnswers }} <br />
        Score: {{ score }}% <br />
        <div v-if="incorrectAnswersList.length > 0" class="mt-3">
          <div class="red--text font-weight-bold">Incorrect answers:</div>
          <v-divider class="my-2"></v-divider>
          <div v-for="incorrectAnswer in incorrectAnswersList" :key="incorrectAnswer.id">
            <div class="red--text" v-html="incorrectAnswer.question"></div>
            <v-divider class="my-2"></v-divider>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          @click="shuffleQuestions"
          v-if="!shuffle"
        >
          <v-icon>mdi-shuffle</v-icon>
          Shuffle
        </v-btn>
        <v-btn
          color="primary"
          small
          @click="resetQuiz"
        >
          <v-icon>mdi-restart</v-icon>
          Reset
        </v-btn>
        <v-btn
          color="primary"
          small
          @click="changeQuestion"
        >
          Set question
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="feedback" :timeout="3000" :color="snackbarColor">
      <span v-html="feedbackText" class="h1"></span>
    </v-snackbar>
    </div>
    <div v-else>
      <v-row justify="center" >
      <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Countdown from "./Countdown";
export default {
  components: {
    Countdown,
  },
  name: "Quiz",
  props: {
    questionsNumber: {
      type: Number,
    },
    shuffle: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    //Load questions from json file
    this.loadQuestions().then((questions) => {
      this.questions = questions;
      if(this.shuffle) {
        this.shuffleQuestions();
      }
      if(this.questionsNumber && this.questionsNumber > 0) {
        this.questions = this.questions.slice(0, this.questionsNumber);
      }
      //45 seconds per question
      this.startTimer(45 * this.questions.length);
      this.currentQuestion = 0;
    });
  },
  data: () => ({
    questions: [],
    currentQuestion: -1,
    correctAnswers: 0,
    incorrectAnswers: 0,
    selected: [],
    revealAnswer: false,
    feedback: false,
    feedbackText: "",
    snackbarColor: "",
    endDate: null,
    incorrectAnswersList: [],
  }),
  computed: {
    question() {
      return this.questions[this.currentQuestion].question;
    },
    options() {
      return this.questions[this.currentQuestion].answers;
    },
    answer() {
      return this.questions[this.currentQuestion].correctAnswers;
    },
    score() {
      return (
        Math.floor(
          (this.correctAnswers /
            (this.correctAnswers + this.incorrectAnswers)) *
            100
        ) || 0
      );
    },
  },
  watch: {
  currentQuestion() {
      //shuffle answers
      this.questions[this.currentQuestion].answers = this.questions[
        this.currentQuestion
      ].answers.sort(() => Math.random() - 0.5);
    },
  },
  methods: {
    loadQuestions() {
      //Load questions from json file
      return fetch("questions.json")
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
    },
    checkAnswer() {
      this.revealAnswer = true;

      if (this.selected.length === this.answer.length) {
        //eslint-disable-next-line
        if (this.selected.every((v, i) => this.answer.includes(v))) {
          this.correctAnswers++;
          this.correctAlert();
        } else {
          this.incorrectAnswers++;
          this.incorrectAlert();
          //Save the incorrect question
          this.incorrectAnswersList.push({
            question: this.question,
          });
        }
      } else {
        this.incorrectAnswers++;
      }
    },
    correctAlert() {
      this.feedback = true;
      this.feedbackText = "Correct!";
      this.snackbarColor = "success";
    },
    incorrectAlert() {
      this.feedback = true;
      this.feedbackText = "Incorrect!";
      this.snackbarColor = "error";
    },
    nextQuestion() {
      this.selected = [];
      this.revealAnswer = false;
      this.feedback = false;
      this.currentQuestion++;
    },
    resetQuiz() {
      this.selected = [];
      this.revealAnswer = false;
      this.currentQuestion = 0;
      this.correctAnswers = 0;
      this.incorrectAnswers = 0;
      this.feedback = false;
      this.startTimer(45 * this.questions.length);
    },
    changeQuestion() {
      let question = +prompt("Enter question number") - 1;
      if (question >= 0 && question < this.questions.length) {
        this.currentQuestion = question;
      }else {
        alert("Invalid question number");
        return;
      }
      this.selected = [];
      this.revealAnswer = false;
      
    },
    shuffleQuestions() {
      this.questions = this.questions
        .map((n) => [Math.random(), n])
        .sort()
        .map((n) => n[1]);
    },
    startTimer(seconds) {
      this.endDate = new Date(new Date().getTime() + seconds * 1000);
    },
    searchQuestion() {
      //Open Google search in a new tab with the question
      window.open(
        "https://www.google.com/search?q=" + this.question,
        "_blank"
      );
    },
  },
};
</script>
